import React from "react";


export default function FieldDropdown_TableValueNotEmpty(props:any) {

    const {option} = props;

    const optionColor = _.get(option, 'color', null); //!_.isNil(option.color) ? option.color : null;

    if (optionColor) {

        const pillClasses = Classes(
            "ui5-pillbox s26 selector",
            "m-l-10",
            "gd-c-bgp-"+optionColor,
            "gd-c-pale-border-"+optionColor,
            props.className
        );

        return (
            <React.Fragment>
                <div className={pillClasses} onClick={props.onClick}>
                    {option.label}
                </div>
                {props.children}
            </React.Fragment>
        )
    }

    const valueClasses = Classes("ui5-txt-default ui5-field-dropdown-inline-editable", props.className)

    return (
        <React.Fragment>
            <div className={valueClasses} onClick={props.onClick}>
                {_.get(props.field.components, 'ValueIcon', false)}
                {_.get(props.field.components, 'ValuePrefix', false)}
                {option.label}
            </div>
            {props.children}
        </React.Fragment>
    );



}
